import { IRiderDetail } from '../models/IRider';
import ITagRegistration from '../models/ITagRegistration';
import { IUser } from '../models/IUser';
import IUserParticipation from '../models/IUserParticipation';
import IUserTag from '../models/IUserTag';
import { axiosInstance } from './ServiceConstants';
import { CancelToken } from 'axios';

class UserService {
    async updateUserProfile(userProfile: IUser ): Promise<IUser> {
        const response = await axiosInstance.post<IUser>(`api/user/me`, userProfile);
        return response.data;
    }

    async getLoggedInUser(cancelToken?: CancelToken): Promise<IUser> {
        const response = await axiosInstance.get<IUser>('api/user/me', { cancelToken });
        return response.data
    }

    async getUserTags(cancelToken?: CancelToken): Promise<IUserTag[]> {
        const response = await axiosInstance.get<IUserTag[]>('api/user/tags', { cancelToken });
        return response.data;
    }
    async getUserHistory(cancelToken?: CancelToken): Promise<IUserParticipation[]> {
        const response = await axiosInstance.get<IUserParticipation[]>(`api/user`, { cancelToken });
        return response.data;
    }

    async getUserParticipation(raceId: string): Promise<IRiderDetail> {
        const response = await axiosInstance.get<IRiderDetail>(`api/user/${raceId}`);
        return response.data;
    }

    async registerTag(tagRegistration: ITagRegistration) {
        await axiosInstance.post('api/user/registerTag');
    }
}

const UserServiceInstance = new UserService();

export default UserServiceInstance;